var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { decorate, observable, action } from 'mobx';
var TicketTableStore = /** @class */ (function () {
    function TicketTableStore() {
        this.assignTableOrder = {
            orderBy: 'id',
            orderDirection: 'desc'
        };
    }
    TicketTableStore.prototype.setAssignTableOrder = function (order) {
        this.assignTableOrder = __assign({}, order);
    };
    __decorate([
        action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], TicketTableStore.prototype, "setAssignTableOrder", null);
    return TicketTableStore;
}());
export { TicketTableStore };
decorate(TicketTableStore, {
    assignTableOrder: observable
});
export default new TicketTableStore();
